// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/task/v1/insights.proto" (package "c1.api.task.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { GrantReason } from "../../app/v1/app_entitlement_user_binding_reasons";
import { UserAttributeMappingSource } from "../../user/v1/user";
import { Outcome } from "../../analysis/v1/analysis";
import { Timestamp } from "../../../../google/protobuf/timestamp";
import { UserStatus } from "../../user/v1/user";
/**
 * @generated from protobuf message c1.api.task.v1.Insight
 */
export interface Insight {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
    /**
     * @generated from protobuf field: string ticket_id = 2
     */
    ticketId: string;
    /**
     * @generated from protobuf field: c1.api.task.v1.InsightType type = 3
     */
    type: InsightType;
    /**
     * @generated from protobuf oneof: kind
     */
    kind: {
        oneofKind: "cost";
        /**
         * @generated from protobuf field: c1.api.task.v1.CostInsight cost = 100
         */
        cost: CostInsight;
    } | {
        oneofKind: "userStatus";
        /**
         * @generated from protobuf field: c1.api.task.v1.UserStatusInsight user_status = 101
         */
        userStatus: UserStatusInsight;
    } | {
        oneofKind: "usage";
        /**
         * @generated from protobuf field: c1.api.task.v1.UsageInsight usage = 102
         */
        usage: UsageInsight;
    } | {
        oneofKind: "risk";
        /**
         * @generated from protobuf field: c1.api.task.v1.RiskInsight risk = 103
         */
        risk: RiskInsight;
    } | {
        oneofKind: "analysis";
        /**
         * @generated from protobuf field: c1.api.task.v1.AnalysisInsight analysis = 104
         */
        analysis: AnalysisInsight;
    } | {
        oneofKind: "employmentStatus";
        /**
         * @generated from protobuf field: c1.api.task.v1.EmploymentStatusInsight employment_status = 105
         */
        employmentStatus: EmploymentStatusInsight;
    } | {
        oneofKind: "complianceFramework";
        /**
         * @generated from protobuf field: c1.api.task.v1.ComplianceFrameworkInsight compliance_framework = 106
         */
        complianceFramework: ComplianceFrameworkInsight;
    } | {
        oneofKind: "grantOrigin";
        /**
         * @generated from protobuf field: c1.api.task.v1.GrantOriginInsight grant_origin = 107
         */
        grantOrigin: GrantOriginInsight;
    } | {
        oneofKind: "externalSecurity";
        /**
         * @generated from protobuf field: c1.api.task.v1.ExternalSecurityInsight external_security = 108
         */
        externalSecurity: ExternalSecurityInsight;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.task.v1.CostInsight
 */
export interface CostInsight {
    /**
     * @generated from protobuf field: int32 monthly_cost_usd = 1
     */
    monthlyCostUsd: number;
}
/**
 * @generated from protobuf message c1.api.task.v1.UserStatusInsight
 */
export interface UserStatusInsight {
    /**
     * @generated from protobuf field: c1.api.user.v1.UserStatus user_status = 1
     */
    userStatus: UserStatus;
}
/**
 * @generated from protobuf message c1.api.task.v1.UsageInsight
 */
export interface UsageInsight {
    /**
     * @generated from protobuf field: google.protobuf.Timestamp last_used_at = 1
     */
    lastUsedAt?: Timestamp;
}
/**
 * @generated from protobuf message c1.api.task.v1.RiskInsight
 */
export interface RiskInsight {
    /**
     * @generated from protobuf field: string risk_level_value_id = 1
     */
    riskLevelValueId: string;
}
/**
 * @generated from protobuf message c1.api.task.v1.AnalysisInsight
 */
export interface AnalysisInsight {
    /**
     * @generated from protobuf field: c1.api.analysis.v1.Outcome outcome = 2
     */
    outcome?: Outcome;
}
/**
 * @generated from protobuf message c1.api.task.v1.EmploymentStatusInsight
 */
export interface EmploymentStatusInsight {
    /**
     * @generated from protobuf field: string employment_status = 1
     */
    employmentStatus: string;
    /**
     * @generated from protobuf field: repeated c1.api.user.v1.UserAttributeMappingSource employment_status_sources = 2
     */
    employmentStatusSources: UserAttributeMappingSource[];
}
/**
 * @generated from protobuf message c1.api.task.v1.ComplianceFrameworkInsight
 */
export interface ComplianceFrameworkInsight {
    /**
     * @generated from protobuf field: repeated string compliance_framework_ids = 1
     */
    complianceFrameworkIds: string[];
}
/**
 * @generated from protobuf message c1.api.task.v1.GrantOriginInsight
 */
export interface GrantOriginInsight {
    /**
     * @generated from protobuf field: c1.api.app.v1.GrantReason grant_reason = 1
     */
    grantReason?: GrantReason;
}
/**
 * ExternalSecurityInsight represents security insights from external sources
 * (e.g., CrowdStrike ZTA scores, Wiz vulnerabilities)
 *
 * @generated from protobuf message c1.api.task.v1.ExternalSecurityInsight
 */
export interface ExternalSecurityInsight {
    /**
     * The source app that provided this insight
     *
     * @generated from protobuf field: string source_app_id = 1
     */
    sourceAppId: string;
    /**
     * The ID of the SecurityInsight this was created from
     *
     * @generated from protobuf field: string security_insight_id = 2
     */
    securityInsightId: string;
    /**
     * Mirrors SecurityInsight.insight_type from security_insight.proto
     *
     * @generated from protobuf oneof: insight_type
     */
    insightType: {
        oneofKind: "riskScore";
        /**
         * @generated from protobuf field: c1.api.task.v1.ExternalRiskScore risk_score = 100
         */
        riskScore: ExternalRiskScore;
    } | {
        oneofKind: "issue";
        /**
         * @generated from protobuf field: c1.api.task.v1.ExternalIssue issue = 101
         */
        issue: ExternalIssue;
    } | {
        oneofKind: undefined;
    };
}
/**
 * ExternalRiskScore represents a risk score from an external source
 *
 * @generated from protobuf message c1.api.task.v1.ExternalRiskScore
 */
export interface ExternalRiskScore {
    /**
     * The risk score value (e.g., "85", "High", "42/100")
     *
     * @generated from protobuf field: string value = 1
     */
    value: string;
}
/**
 * ExternalIssue represents a security issue from an external source
 *
 * @generated from protobuf message c1.api.task.v1.ExternalIssue
 */
export interface ExternalIssue {
    /**
     * The issue description or count (e.g., "3 Critical CVEs", "S3 Bucket Publicly Accessible")
     *
     * @generated from protobuf field: string value = 1
     */
    value: string;
    /**
     * The severity level (e.g., "CRITICAL", "HIGH", "MEDIUM", "LOW")
     *
     * @generated from protobuf field: string severity = 2
     */
    severity: string;
}
/**
 * @generated from protobuf enum c1.api.task.v1.InsightType
 */
export enum InsightType {
    /**
     * @generated from protobuf enum value: INSIGHT_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: INSIGHT_TYPE_NEUTRAL = 1;
     */
    NEUTRAL = 1,
    /**
     * @generated from protobuf enum value: INSIGHT_TYPE_POSITIVE = 2;
     */
    POSITIVE = 2,
    /**
     * @generated from protobuf enum value: INSIGHT_TYPE_NEGATIVE = 3;
     */
    NEGATIVE = 3,
    /**
     * @generated from protobuf enum value: INSIGHT_TYPE_ALERT = 4;
     */
    ALERT = 4
}
/**
 * @generated from protobuf enum c1.api.task.v1.InsightRecommendation
 */
export enum InsightRecommendation {
    /**
     * @generated from protobuf enum value: INSIGHT_RECOMMENDATION_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: INSIGHT_RECOMMENDATION_APPROVE = 1;
     */
    APPROVE = 1,
    /**
     * @generated from protobuf enum value: INSIGHT_RECOMMENDATION_DENY = 2;
     */
    DENY = 2,
    /**
     * @generated from protobuf enum value: INSIGHT_RECOMMENDATION_REVIEW = 3;
     */
    REVIEW = 3
}
// @generated message type with reflection information, may provide speed optimized methods
class Insight$Type extends MessageType<Insight> {
    constructor() {
        super("c1.api.task.v1.Insight", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "ticket_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "type", kind: "enum", T: () => ["c1.api.task.v1.InsightType", InsightType, "INSIGHT_TYPE_"] },
            { no: 100, name: "cost", kind: "message", oneof: "kind", T: () => CostInsight },
            { no: 101, name: "user_status", kind: "message", oneof: "kind", T: () => UserStatusInsight },
            { no: 102, name: "usage", kind: "message", oneof: "kind", T: () => UsageInsight },
            { no: 103, name: "risk", kind: "message", oneof: "kind", T: () => RiskInsight },
            { no: 104, name: "analysis", kind: "message", oneof: "kind", T: () => AnalysisInsight },
            { no: 105, name: "employment_status", kind: "message", oneof: "kind", T: () => EmploymentStatusInsight },
            { no: 106, name: "compliance_framework", kind: "message", oneof: "kind", T: () => ComplianceFrameworkInsight },
            { no: 107, name: "grant_origin", kind: "message", oneof: "kind", T: () => GrantOriginInsight },
            { no: 108, name: "external_security", kind: "message", oneof: "kind", T: () => ExternalSecurityInsight }
        ]);
    }
    create(value?: PartialMessage<Insight>): Insight {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        message.ticketId = "";
        message.type = 0;
        message.kind = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<Insight>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Insight): Insight {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string ticket_id */ 2:
                    message.ticketId = reader.string();
                    break;
                case /* c1.api.task.v1.InsightType type */ 3:
                    message.type = reader.int32();
                    break;
                case /* c1.api.task.v1.CostInsight cost */ 100:
                    message.kind = {
                        oneofKind: "cost",
                        cost: CostInsight.internalBinaryRead(reader, reader.uint32(), options, (message.kind as any).cost)
                    };
                    break;
                case /* c1.api.task.v1.UserStatusInsight user_status */ 101:
                    message.kind = {
                        oneofKind: "userStatus",
                        userStatus: UserStatusInsight.internalBinaryRead(reader, reader.uint32(), options, (message.kind as any).userStatus)
                    };
                    break;
                case /* c1.api.task.v1.UsageInsight usage */ 102:
                    message.kind = {
                        oneofKind: "usage",
                        usage: UsageInsight.internalBinaryRead(reader, reader.uint32(), options, (message.kind as any).usage)
                    };
                    break;
                case /* c1.api.task.v1.RiskInsight risk */ 103:
                    message.kind = {
                        oneofKind: "risk",
                        risk: RiskInsight.internalBinaryRead(reader, reader.uint32(), options, (message.kind as any).risk)
                    };
                    break;
                case /* c1.api.task.v1.AnalysisInsight analysis */ 104:
                    message.kind = {
                        oneofKind: "analysis",
                        analysis: AnalysisInsight.internalBinaryRead(reader, reader.uint32(), options, (message.kind as any).analysis)
                    };
                    break;
                case /* c1.api.task.v1.EmploymentStatusInsight employment_status */ 105:
                    message.kind = {
                        oneofKind: "employmentStatus",
                        employmentStatus: EmploymentStatusInsight.internalBinaryRead(reader, reader.uint32(), options, (message.kind as any).employmentStatus)
                    };
                    break;
                case /* c1.api.task.v1.ComplianceFrameworkInsight compliance_framework */ 106:
                    message.kind = {
                        oneofKind: "complianceFramework",
                        complianceFramework: ComplianceFrameworkInsight.internalBinaryRead(reader, reader.uint32(), options, (message.kind as any).complianceFramework)
                    };
                    break;
                case /* c1.api.task.v1.GrantOriginInsight grant_origin */ 107:
                    message.kind = {
                        oneofKind: "grantOrigin",
                        grantOrigin: GrantOriginInsight.internalBinaryRead(reader, reader.uint32(), options, (message.kind as any).grantOrigin)
                    };
                    break;
                case /* c1.api.task.v1.ExternalSecurityInsight external_security */ 108:
                    message.kind = {
                        oneofKind: "externalSecurity",
                        externalSecurity: ExternalSecurityInsight.internalBinaryRead(reader, reader.uint32(), options, (message.kind as any).externalSecurity)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Insight, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string ticket_id = 2; */
        if (message.ticketId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.ticketId);
        /* c1.api.task.v1.InsightType type = 3; */
        if (message.type !== 0)
            writer.tag(3, WireType.Varint).int32(message.type);
        /* c1.api.task.v1.CostInsight cost = 100; */
        if (message.kind.oneofKind === "cost")
            CostInsight.internalBinaryWrite(message.kind.cost, writer.tag(100, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.task.v1.UserStatusInsight user_status = 101; */
        if (message.kind.oneofKind === "userStatus")
            UserStatusInsight.internalBinaryWrite(message.kind.userStatus, writer.tag(101, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.task.v1.UsageInsight usage = 102; */
        if (message.kind.oneofKind === "usage")
            UsageInsight.internalBinaryWrite(message.kind.usage, writer.tag(102, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.task.v1.RiskInsight risk = 103; */
        if (message.kind.oneofKind === "risk")
            RiskInsight.internalBinaryWrite(message.kind.risk, writer.tag(103, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.task.v1.AnalysisInsight analysis = 104; */
        if (message.kind.oneofKind === "analysis")
            AnalysisInsight.internalBinaryWrite(message.kind.analysis, writer.tag(104, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.task.v1.EmploymentStatusInsight employment_status = 105; */
        if (message.kind.oneofKind === "employmentStatus")
            EmploymentStatusInsight.internalBinaryWrite(message.kind.employmentStatus, writer.tag(105, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.task.v1.ComplianceFrameworkInsight compliance_framework = 106; */
        if (message.kind.oneofKind === "complianceFramework")
            ComplianceFrameworkInsight.internalBinaryWrite(message.kind.complianceFramework, writer.tag(106, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.task.v1.GrantOriginInsight grant_origin = 107; */
        if (message.kind.oneofKind === "grantOrigin")
            GrantOriginInsight.internalBinaryWrite(message.kind.grantOrigin, writer.tag(107, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.task.v1.ExternalSecurityInsight external_security = 108; */
        if (message.kind.oneofKind === "externalSecurity")
            ExternalSecurityInsight.internalBinaryWrite(message.kind.externalSecurity, writer.tag(108, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.Insight
 */
export const Insight = new Insight$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CostInsight$Type extends MessageType<CostInsight> {
    constructor() {
        super("c1.api.task.v1.CostInsight", [
            { no: 1, name: "monthly_cost_usd", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<CostInsight>): CostInsight {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.monthlyCostUsd = 0;
        if (value !== undefined)
            reflectionMergePartial<CostInsight>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CostInsight): CostInsight {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 monthly_cost_usd */ 1:
                    message.monthlyCostUsd = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CostInsight, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 monthly_cost_usd = 1; */
        if (message.monthlyCostUsd !== 0)
            writer.tag(1, WireType.Varint).int32(message.monthlyCostUsd);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.CostInsight
 */
export const CostInsight = new CostInsight$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserStatusInsight$Type extends MessageType<UserStatusInsight> {
    constructor() {
        super("c1.api.task.v1.UserStatusInsight", [
            { no: 1, name: "user_status", kind: "enum", T: () => ["c1.api.user.v1.UserStatus", UserStatus] }
        ]);
    }
    create(value?: PartialMessage<UserStatusInsight>): UserStatusInsight {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.userStatus = 0;
        if (value !== undefined)
            reflectionMergePartial<UserStatusInsight>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UserStatusInsight): UserStatusInsight {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.user.v1.UserStatus user_status */ 1:
                    message.userStatus = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UserStatusInsight, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.user.v1.UserStatus user_status = 1; */
        if (message.userStatus !== 0)
            writer.tag(1, WireType.Varint).int32(message.userStatus);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.UserStatusInsight
 */
export const UserStatusInsight = new UserStatusInsight$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UsageInsight$Type extends MessageType<UsageInsight> {
    constructor() {
        super("c1.api.task.v1.UsageInsight", [
            { no: 1, name: "last_used_at", kind: "message", T: () => Timestamp }
        ]);
    }
    create(value?: PartialMessage<UsageInsight>): UsageInsight {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UsageInsight>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UsageInsight): UsageInsight {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* google.protobuf.Timestamp last_used_at */ 1:
                    message.lastUsedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.lastUsedAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UsageInsight, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* google.protobuf.Timestamp last_used_at = 1; */
        if (message.lastUsedAt)
            Timestamp.internalBinaryWrite(message.lastUsedAt, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.UsageInsight
 */
export const UsageInsight = new UsageInsight$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RiskInsight$Type extends MessageType<RiskInsight> {
    constructor() {
        super("c1.api.task.v1.RiskInsight", [
            { no: 1, name: "risk_level_value_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<RiskInsight>): RiskInsight {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.riskLevelValueId = "";
        if (value !== undefined)
            reflectionMergePartial<RiskInsight>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RiskInsight): RiskInsight {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string risk_level_value_id */ 1:
                    message.riskLevelValueId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RiskInsight, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string risk_level_value_id = 1; */
        if (message.riskLevelValueId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.riskLevelValueId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.RiskInsight
 */
export const RiskInsight = new RiskInsight$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AnalysisInsight$Type extends MessageType<AnalysisInsight> {
    constructor() {
        super("c1.api.task.v1.AnalysisInsight", [
            { no: 2, name: "outcome", kind: "message", T: () => Outcome }
        ]);
    }
    create(value?: PartialMessage<AnalysisInsight>): AnalysisInsight {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<AnalysisInsight>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AnalysisInsight): AnalysisInsight {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.analysis.v1.Outcome outcome */ 2:
                    message.outcome = Outcome.internalBinaryRead(reader, reader.uint32(), options, message.outcome);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AnalysisInsight, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.analysis.v1.Outcome outcome = 2; */
        if (message.outcome)
            Outcome.internalBinaryWrite(message.outcome, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.AnalysisInsight
 */
export const AnalysisInsight = new AnalysisInsight$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EmploymentStatusInsight$Type extends MessageType<EmploymentStatusInsight> {
    constructor() {
        super("c1.api.task.v1.EmploymentStatusInsight", [
            { no: 1, name: "employment_status", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "employment_status_sources", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UserAttributeMappingSource }
        ]);
    }
    create(value?: PartialMessage<EmploymentStatusInsight>): EmploymentStatusInsight {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.employmentStatus = "";
        message.employmentStatusSources = [];
        if (value !== undefined)
            reflectionMergePartial<EmploymentStatusInsight>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: EmploymentStatusInsight): EmploymentStatusInsight {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string employment_status */ 1:
                    message.employmentStatus = reader.string();
                    break;
                case /* repeated c1.api.user.v1.UserAttributeMappingSource employment_status_sources */ 2:
                    message.employmentStatusSources.push(UserAttributeMappingSource.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: EmploymentStatusInsight, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string employment_status = 1; */
        if (message.employmentStatus !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.employmentStatus);
        /* repeated c1.api.user.v1.UserAttributeMappingSource employment_status_sources = 2; */
        for (let i = 0; i < message.employmentStatusSources.length; i++)
            UserAttributeMappingSource.internalBinaryWrite(message.employmentStatusSources[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.EmploymentStatusInsight
 */
export const EmploymentStatusInsight = new EmploymentStatusInsight$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ComplianceFrameworkInsight$Type extends MessageType<ComplianceFrameworkInsight> {
    constructor() {
        super("c1.api.task.v1.ComplianceFrameworkInsight", [
            { no: 1, name: "compliance_framework_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ComplianceFrameworkInsight>): ComplianceFrameworkInsight {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.complianceFrameworkIds = [];
        if (value !== undefined)
            reflectionMergePartial<ComplianceFrameworkInsight>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ComplianceFrameworkInsight): ComplianceFrameworkInsight {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string compliance_framework_ids */ 1:
                    message.complianceFrameworkIds.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ComplianceFrameworkInsight, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated string compliance_framework_ids = 1; */
        for (let i = 0; i < message.complianceFrameworkIds.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.complianceFrameworkIds[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.ComplianceFrameworkInsight
 */
export const ComplianceFrameworkInsight = new ComplianceFrameworkInsight$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GrantOriginInsight$Type extends MessageType<GrantOriginInsight> {
    constructor() {
        super("c1.api.task.v1.GrantOriginInsight", [
            { no: 1, name: "grant_reason", kind: "message", T: () => GrantReason }
        ]);
    }
    create(value?: PartialMessage<GrantOriginInsight>): GrantOriginInsight {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GrantOriginInsight>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GrantOriginInsight): GrantOriginInsight {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.app.v1.GrantReason grant_reason */ 1:
                    message.grantReason = GrantReason.internalBinaryRead(reader, reader.uint32(), options, message.grantReason);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GrantOriginInsight, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.app.v1.GrantReason grant_reason = 1; */
        if (message.grantReason)
            GrantReason.internalBinaryWrite(message.grantReason, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.GrantOriginInsight
 */
export const GrantOriginInsight = new GrantOriginInsight$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ExternalSecurityInsight$Type extends MessageType<ExternalSecurityInsight> {
    constructor() {
        super("c1.api.task.v1.ExternalSecurityInsight", [
            { no: 1, name: "source_app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "security_insight_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 100, name: "risk_score", kind: "message", oneof: "insightType", T: () => ExternalRiskScore },
            { no: 101, name: "issue", kind: "message", oneof: "insightType", T: () => ExternalIssue }
        ]);
    }
    create(value?: PartialMessage<ExternalSecurityInsight>): ExternalSecurityInsight {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.sourceAppId = "";
        message.securityInsightId = "";
        message.insightType = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<ExternalSecurityInsight>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ExternalSecurityInsight): ExternalSecurityInsight {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string source_app_id */ 1:
                    message.sourceAppId = reader.string();
                    break;
                case /* string security_insight_id */ 2:
                    message.securityInsightId = reader.string();
                    break;
                case /* c1.api.task.v1.ExternalRiskScore risk_score */ 100:
                    message.insightType = {
                        oneofKind: "riskScore",
                        riskScore: ExternalRiskScore.internalBinaryRead(reader, reader.uint32(), options, (message.insightType as any).riskScore)
                    };
                    break;
                case /* c1.api.task.v1.ExternalIssue issue */ 101:
                    message.insightType = {
                        oneofKind: "issue",
                        issue: ExternalIssue.internalBinaryRead(reader, reader.uint32(), options, (message.insightType as any).issue)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ExternalSecurityInsight, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string source_app_id = 1; */
        if (message.sourceAppId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.sourceAppId);
        /* string security_insight_id = 2; */
        if (message.securityInsightId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.securityInsightId);
        /* c1.api.task.v1.ExternalRiskScore risk_score = 100; */
        if (message.insightType.oneofKind === "riskScore")
            ExternalRiskScore.internalBinaryWrite(message.insightType.riskScore, writer.tag(100, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.task.v1.ExternalIssue issue = 101; */
        if (message.insightType.oneofKind === "issue")
            ExternalIssue.internalBinaryWrite(message.insightType.issue, writer.tag(101, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.ExternalSecurityInsight
 */
export const ExternalSecurityInsight = new ExternalSecurityInsight$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ExternalRiskScore$Type extends MessageType<ExternalRiskScore> {
    constructor() {
        super("c1.api.task.v1.ExternalRiskScore", [
            { no: 1, name: "value", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ExternalRiskScore>): ExternalRiskScore {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.value = "";
        if (value !== undefined)
            reflectionMergePartial<ExternalRiskScore>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ExternalRiskScore): ExternalRiskScore {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string value */ 1:
                    message.value = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ExternalRiskScore, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string value = 1; */
        if (message.value !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.value);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.ExternalRiskScore
 */
export const ExternalRiskScore = new ExternalRiskScore$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ExternalIssue$Type extends MessageType<ExternalIssue> {
    constructor() {
        super("c1.api.task.v1.ExternalIssue", [
            { no: 1, name: "value", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "severity", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ExternalIssue>): ExternalIssue {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.value = "";
        message.severity = "";
        if (value !== undefined)
            reflectionMergePartial<ExternalIssue>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ExternalIssue): ExternalIssue {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string value */ 1:
                    message.value = reader.string();
                    break;
                case /* string severity */ 2:
                    message.severity = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ExternalIssue, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string value = 1; */
        if (message.value !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.value);
        /* string severity = 2; */
        if (message.severity !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.severity);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.ExternalIssue
 */
export const ExternalIssue = new ExternalIssue$Type();
